export default __webpack_public_path__ + "media/images/react_icons/whatsapp_alt-d08ec0131de9ff809a679ccd118c387e.svg";